export default import.meta.ROLLDOWN_FILE_URL_FJ7w2ScN3fXgpmI7X7BK5g